import React from "react";
import { BarChart3, Gauge, Mic2, Volume2 } from "lucide-react";

const scoreRows = [
  {
    label: "Content",
    key: "contentScore",
    icon: BarChart3,
    tone: "bg-blue-50 text-blue-700 ring-blue-100",
  },
  {
    label: "Fluency",
    key: "fluencyScore",
    icon: Gauge,
    tone: "bg-green-50 text-green-700 ring-green-100",
  },
  {
    label: "Pronunciation",
    key: "pronounctionScore",
    icon: Mic2,
    tone: "bg-purple-50 text-purple-700 ring-purple-100",
  },
];

const formatScore = (score) => (score || score === 0 ? score : "N/A");

export default function ScoreCard(props) {
  const finalScore = formatScore(props.finalScore);
  const maxScore = props.maxScore || 90;
  const traitMaxScore = props.traitMaxScore || 90;
  const traitMaxScores = props.traitMaxScores || {};

  return (
    <div className="overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm">
      <div className="grid gap-0 lg:grid-cols-[minmax(260px,0.9fr),1.1fr]">
        <div className="bg-violet-600 p-6 text-white">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-semibold uppercase text-violet-100">
                Total score
              </p>
              <h3 className="mt-1 text-2xl font-extrabold">Score card</h3>
            </div>
            <span className="grid h-11 w-11 place-items-center rounded-md bg-white/15">
              <Volume2 className="h-5 w-5" aria-hidden="true" />
            </span>
          </div>

          <div className="mt-8 flex items-end gap-2">
            <span className="text-6xl font-extrabold leading-none">
              {finalScore}
            </span>
            <span className="pb-2 text-sm font-bold text-violet-100">
              / {maxScore}
            </span>
          </div>

          <div className="mt-6 rounded-md bg-white/10 p-4">
            <p className="text-xs font-semibold uppercase text-violet-100">
              Remarks
            </p>
            <p className="mt-1 text-xl font-extrabold">
              {props.remarks || "Awaiting feedback"}
            </p>
          </div>
        </div>

        <div className="p-5 sm:p-6">
          <p className="text-sm font-semibold uppercase text-purple-700">
            Breakdown
          </p>
          <h4 className="mt-1 text-xl font-extrabold text-gray-900">
            Speaking performance
          </h4>

          <div className="mt-5 grid gap-3">
            {scoreRows.map((row) => {
              const Icon = row.icon;
              const score = formatScore(props[row.key]);
              const rowMaxScore = traitMaxScores[row.key] || traitMaxScore;

              return (
                <div
                  key={row.key}
                  className="flex items-center justify-between gap-3 rounded-md border border-slate-200 bg-slate-50 p-4"
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`grid h-10 w-10 shrink-0 place-items-center rounded-md ring-1 ${row.tone}`}
                    >
                      <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <span className="font-bold text-gray-800">{row.label}</span>
                  </div>
                  <span className="text-lg font-extrabold text-gray-900">
                    {score}/{rowMaxScore}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
